import * as React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import ListItem from '@mui/material/ListItem';
import Grid from '@mui/material/Grid';
import { ClickAwayListener, Stack, Chip, Divider, Link, ListItemText, ListItemButton } from '@mui/material';
import { keyframes } from '@emotion/react';

// Logo URLs from static folder so they load on every route (including dynamic integration pages)
const STATIC_LOGOS = [
    '/images/Visa-Logo.png',
    '/images/Digital-Turbine-Logo.png',
    '/images/Lever%20Logo%20-%20Edited.png',
    '/images/ACE-Hardware-logo.png',
    '/images/Delphix-Logo.png',
];

function LogoMain(props) {
    const slideAnimation = keyframes`
        0% {
            transform: translateX(0);
        }
        100% {
            transform: translateX(calc(-16.666% * 6));  // Move by one logo at a time
        }
    `;

    const logoStyle = {
        height: '100px',
        filter: "grayscale(100%)",
        opacity: 0.6,
        objectFit: 'contain',
        transition: 'opacity 0.3s ease-in-out',
        padding: '0'
    };

    const containerStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: '1200px',
        borderRadius: 2,
        paddingTop: '1.5rem',
        paddingBottom: '0.25rem',
        overflow: 'hidden',
        minHeight: '100px',
        position: 'relative',
        marginBottom: '1rem',
        bgcolor: '#fff'
    };

    const wrapperStyle = {
        overflow: 'hidden',
        width: '100%',
        position: 'relative'
    };

    const carouselStyle = {
        display: 'flex',
        gap: '0',  // Removed gap completely
        animation: `${slideAnimation} 18s linear infinite`,
        position: 'relative',
        left: 0,
        width: 'max-content'
    };

    const logoContainerStyle = {
        flex: '0 0 calc(16.666%)',  // Removed gap calculation
        opacity: 1,
        height: '100px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0',
        margin: '0'
    };

    // Double the logos for seamless infinite scroll
    return (
        <Container sx={containerStyle}>
            <Box sx={wrapperStyle}>
                <Box sx={carouselStyle}>
                    {/* First set of logos */}
                    <Box sx={logoContainerStyle}>
                        <img
                            src={props.img[0]}
                            alt="Partner logo 1"
                            style={logoStyle}
                        />
                    </Box>
                    {STATIC_LOGOS.map((src, i) => (
                        <Box key={`a-${i}`} sx={logoContainerStyle}>
                            <img
                                src={src}
                                alt={`Partner logo ${i + 2}`}
                                style={logoStyle}
                            />
                        </Box>
                    ))}
                    {/* Duplicate set of logos for seamless loop */}
                    <Box sx={logoContainerStyle}>
                        <img
                            src={props.img[0]}
                            alt="Partner logo 1"
                            style={logoStyle}
                        />
                    </Box>
                    {STATIC_LOGOS.map((src, i) => (
                        <Box key={`b-${i}`} sx={logoContainerStyle}>
                            <img
                                src={src}
                                alt={`Partner logo ${i + 2}`}
                                style={logoStyle}
                            />
                        </Box>
                    ))}
                </Box>
            </Box>
        </Container>
    );
}

export default LogoMain;